// extracted by mini-css-extract-plugin
module.exports = {"textOrange":"Metrix_textOrange__MEQVD"};